import { ComputedRef } from 'vue'

import { JudgeDetail } from '@/domain/entities/judge/judgeDetail'
import { JudgeDetailViewModel } from '@/presentation/viewmodels/judge/judgeDetailViewModel'

export class JudgeDetailPresenter {
  private viewModel: JudgeDetailViewModel

  constructor(viewModel: JudgeDetailViewModel) {
    this.viewModel = viewModel
  }

  get judgeDetail(): ComputedRef<JudgeDetail | null> {
    return this.viewModel.judgeDetail
  }

  get testJudgeDetail(): ComputedRef<JudgeDetail | null> {
    return this.viewModel.testJudgeDetail
  }
}
